// MATCH HEIGHT JS START

// window.setGridHeight = (selector) => {
//   this.heightArray = [];
//   this.offsetArrayArray = [];
//   this.sectionArray = [];

//   document.querySelectorAll(selector).forEach((grid, i) => {
//     var tmp = {
//       index: i,
//       offsetheight: grid.closest(`[data-equal]`).offsetTop,
//     };
//     this.offsetArrayArray.push(tmp);
//   });

//   this.diffrentsHeights = [];
//   this.offsetArrayArray.forEach(function (e) {
//     if (this.diffrentsHeights.includes(e.offsetheight) == false) {
//       this.diffrentsHeights.push(e.offsetheight);
//     }
//   });

//   this.diffrentsHeights.forEach(function (e) {
//     var data = [];
//     for (var i = 0; i < this.offsetArrayArray.length; i++) {
//       if (this.offsetArrayArray[i].offsetheight == e) {
//         data.push(this.offsetArrayArray[i]);
//       }
//     }

//     var getAllHeightArray = [];
//     data.forEach(function (ele) {
//       document.querySelectorAll(selector)[ele.index].removeAttribute("style");
//       getAllHeightArray.push(
//         document.querySelectorAll(selector)[ele.index].offsetHeight
//       );
//     });

//     var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
//     data.forEach(function (ele) {
//       document.querySelectorAll(selector)[ele.index].style.minHeight =
//         getMaxHeight + "px";
//     });
//   });
// };

// window.setGridHeight(
//   ".multicolumn .multicolumn-card .multicolumn-card__info"
// );

// MATCH HEIGHT JS END

jQuery(document).ready(function($) {

  
  $(".footer-block--menu").wrapAll("<div class='footer_menu_wrapper' />");


// ============================ Progressbar JS START
  
  function loading() {
  document.querySelectorAll(".bar").forEach(function(current) {
    let startWidth = 0;
    const endWidth = current.dataset.size;

    const interval = setInterval(frame, 20);

      function frame() {
        if (startWidth >= endWidth) {
          clearInterval(interval);
        } else {
            startWidth++;
            current.style.width = `${endWidth}%`;
            current.firstElementChild.innerText = `${startWidth}%`;
          }
       }
    });
  }

setTimeout(loading, 1000);

// ============================ Progressbar JS END


// ========================== LOGO LIST SLIDER START
  
   $(()=>{
  var createSlick = ()=>{
  let slider = $(".logo_list_items");

      slider.not('.slick-initialized').slick({
        autoplay: true,
        infinite: true,
        dots: false,
        arrows: false,
        pauseOnHover: false,
        cssEase: 'linear',
        autoplaySpeed: 0,
        speed: 8000,
        centerMode: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
              adaptiveHeight: true,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2,
              adaptiveHeight: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      });	
    }
    
      createSlick();
    
     $(window).on('resize orientationchange', createSlick );
    })

// ========================== LOGO LIST SLIDER END
  

// =================================== REVIEW SLIDER START
  
  $(()=>{
  var createSlick = ()=>{
  let slider = $(".review_carousel_items");

      slider.not('.slick-initialized').slick({
        autoplay: false,
        infinite: true,
        dots: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              adaptiveHeight: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              dots: true,
              arrows: false,
              slidesToScroll: 1,
            },
          },
        ],
      });	
    }
    
      createSlick();
    
     $(window).on('resize orientationchange', createSlick );
    })

// =================================== REVIEW SLIDER END
  

// ================================ FEATURED COLLECTION GRID MOBILE SLIDER START
  
  mobileOnlySlider1(".featured_collection .grid", true, false, 767);

  function mobileOnlySlider1($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

  	slider.slick(settings);
  
  	$(window).on("resize", function () {
  		if ($(window).width() > $breakpoint) {
  			return;
  		}
  		if (!slider.hasClass("slick-initialized")) {
  			return slider.slick(settings);
  		}
  	});
  } // Mobile Only Slider

  $('.ambassador_how_it_works .multicolumn-list .multicolumn-card').matchHeight();


// ================================ FEATURED COLLECTION GRID MOBILE SLIDER END 


// ===================================== About page icon text slider
   $(()=>{
  var createSlick = ()=>{
  let slider = $(".about_icon_text_multicolumn .multicolumn-list");

      slider.not('.slick-initialized').slick({
        autoplay: false,
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });	
    }
    
      createSlick();
    
     $(window).on( 'resize orientationchange', createSlick );
    })
// ===================================== About page icon text END

// =============================== Image with text inner slider START
 $(function() {
    $('.stress_ball_hoodie .image-with-text__grid .image-with-text__text-item .image-with-text__content ul').not('.slick-initialized').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
        mobileFirst: true,
        arrows: false,
        dots: true,
        responsive: [
            {
              breakpoint: 989,
              settings: 'unslick'
            }
        ]
    });

    $(window).on('resize', function() {
        $('.stress_ball_hoodie .image-with-text__grid .image-with-text__text-item .image-with-text__content ul').not('.slick-initialized').slick('resize');
    });
  });

// =============================== Image with text inner slider END

// ==================================== FAQ ACCORDION MOBILE START
  
  var $slider = $('.faq_accordion_with_tabbing .faq_wrapper .faq_page_inner ul');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );

  function updateProgress(slick,nextSlide) {
    var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  }
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    // console.log(slick)
    updateProgress(slick,nextSlide);
  });

  $slider.on('init',function (slick) {
    setTimeout(function () {
      updateProgress($(slick.currentTarget)[0].slick,0);
    },1000);
  })
  
  $slider.slick({
    autoplay: false,
    infinite: false,
    arrows: false,
    cssEase: 'ease-out',
    dots: false,
    // draggable: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 400,
    responsive: [
      {
        breakpoint: 99999,
        settings: "unslick",
      },
      {
        breakpoint: 499,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,       
        centerMode: false,      
        initialSlide: 0
        },
      },
    ],
  }); 


// ==================================== FAQ ACCORDION MOBILE END

// ================================== AMBASSADOR HOW IT WORK MOBIOLE START
  
  var $slider = $('.ambassador_how_it_works .multicolumn-list');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
    autoplay: false,
    infinite: true,
    arrows: false,
    cssEase: 'ease-out',
    dots: false,
    draggable: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 400,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 568,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        },
      },
    ],
  });  

// ================================== AMBASSADOR HOW IT WORK MOBIOLE END
  

// ==================================== VIEW AMBASSADOR SLIDER START
  
  var $slider5 = $('.view_ambassador .image_carousel .image_carousel_items');
  var $progressBar5 = $('.progress');
  var $progressBarLabel5 = $( '.slider__label' );
  
  $slider5.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar5
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel5.text( calc + '% completed' );
  });
  
  $slider5.slick({
    autoplay: false,
    infinite: true,
    arrows: false,
    cssEase: 'ease-out',
    dots: false,
    draggable: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 400,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 768,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        },
      },
    ],
  });  

// ==================================== VIEW AMBASSADOR SLIDER END

// ==================================== ABOUT PAGE MULTI SETP FORM SLIDER START
  
  var $slider = $('.about_step_multicolumn .multicolumn .multicolumn-list');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
    autoplay: false,
    infinite: true,
    arrows: false,
    cssEase: 'ease-out',
    dots: false,
    draggable: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 400,
     responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 768,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        },
      },
    ],
  }); 

// ==================================== ABOUT PAGE MULTI SETP FORM SLIDER END

// ============================= PRODUCT BELOW IMAGE TEXT SLIDER START

   var $slider = $('.product_multi_image_below_text .multicolumn .multicolumn-list');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
    autoplay: false,
    infinite: true,
    arrows: false,
    cssEase: 'ease-out',
    dots: false,
    draggable: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 400,
     responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 768,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        },
      },
    ],
  }); 

// ============================= PRODUCT BELOW IMAGE TEXT SLIDER END

// ============================= Exclusive Ambassador Perks slider mobile sTART
  const init3 = {
    autoplay: false,
    infinite: false,
    arrows: false,
    dots: true,
    variableWidth: false,
    cssEase: "linear",
    slidesToShow: 2,
    slidesToScroll: 1,
    swipe: true,
     responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      }
    ]
  };
  
  $(() => {
    const win = $(window);
    const slider = $(".ambassador_perks .multicolumn-list");
  
    win.on("load resize", () => {
      if (win.width() < 990) {
        slider.not(".slick-initialized").slick(init3);
      } else if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
    });
  });  

  // setTimeout(function(){
  //     $('video').trigger('click')
  // },1000);
  
}); 



// ============================= Exclusive Ambassador Perks slider mobile END


// ============================= FOOTER BLOCK ACCORDION JS START =============================================

var acc = document.getElementsByClassName("footer_accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

// ============================= FOOTER BLOCK ACCORDION JS END =============================================


$(".circle_percent").each(function() {
    var $this = $(this),
		$dataV = $this.data("percent"),
		$dataDeg = $dataV * 3.6,
		$round = $this.find(".round_per");
	$round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");	
	$this.append('<div class="circle_inbox"><span class="percent_text"></span></div>');
	$this.prop('Counter', 0).animate({Counter: $dataV},
	{
		duration: 2000, 
		easing: 'swing', 
		step: function (now) {
            $this.find(".percent_text").text(Math.ceil(now)+"%");
        }
    });
	if($dataV >= 51){
		$round.css("transform", "rotate(" + 360 + "deg)");
		setTimeout(function(){
			$this.addClass("percent_more");
		},1000);
		setTimeout(function(){
			$round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");
		},1000);
	} 
});


// SIZE GUIDE MODAL POPUP JS START

// Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var size_btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 
if (size_btn) {
  size_btn.onclick = function() {
    modal.style.display = "block";
  }
}

// When the user clicks on <span> (x), close the modal
if (span) {
  span.onclick = function() {
    modal.style.display = "none";
  }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

// SIZE GUIDE MODAL POPUP JS END


// FLOATING DOTS JS START

const randomX = random(10, 20);
const randomY = random(20, 30);
const randomDelay = random(0, 1);
const randomTime = random(3, 5);
const randomTime2 = random(5, 10);
const randomAngle = random(8, 12);

gsap.set(circle, {
  x: randomX(-1),
  y: randomX(1),
  rotation: randomAngle(-1)
});

moveX(circle, 1);
moveY(circle, -1);
rotate(circle, 1);

function rotate(target, direction) {
  
  gsap.to(target, randomTime2(), {
    rotation: randomAngle(direction),
    // delay: randomDelay(),
    ease: Sine.easeInOut,
    onComplete: rotate,
    onCompleteParams: [target, direction * -1]
  });
}

function moveX(target, direction) {
  
  gsap.to(target, randomTime(), {
    x: randomX(direction),
    ease: Sine.easeInOut,
    onComplete: moveX,
    onCompleteParams: [target, direction * -1]
  });
}

function moveY(target, direction) {
  
  gsap.to(target, randomTime(), {
    y: randomY(direction),
    ease: Sine.easeInOut,
    onComplete: moveY,
    onCompleteParams: [target, direction * -1]
  });
}

function random(min, max) {
  const delta = max - min;
  return (direction = 1) => (min + delta * Math.random()) * direction;
}


// FLOATING DOTS JS END


